export default (v: string | null | boolean) =>
  typeof v === "boolean" || !!v || "Field is required"
